<template>
  <div class="tracks">
    <div class="search-bar">
      <van-search
        v-model="keyword"
        class="round"
        show-action
        shape="round"
        :placeholder="$t('Tracks.dp997c')"
        @search="onSearch"
        @clear="onClear"
      >
        <div slot="action" @click="onSearch">{{ $t('搜索') }}</div>
      </van-search>
    </div>
    <!-- <van-collapse v-model="activeName" accordion @change="onCollapseChange">
      <van-collapse-item
        v-for="warehouse in warehouseList"
        :key="warehouse.PK_ID"
        :title="warehouse.sName"
        :name="warehouse.PK_ID"
      >
        <div>track</div>
      </van-collapse-item>
    </van-collapse> -->
    <main class="card" v-if="tracks.length">
      <div class="mb-x">{{ $t('订单轨迹详情') }}</div>
      <div class="f-12 mb-x">{{ $t('运单号') }}：{{ orderNo }}</div>

      <div class="progress-container" v-if="progressPercentage >= 0">
        <div class="progress-label">
          <span>{{ $t('物流进度') }}</span>
        </div>
        <div class="progress-bar-wrapper">
          <van-progress
            :percentage="progressPercentage"
            stroke-width="16"
            :show-pivot="true"
            color="#4588ec"
          />
        </div>
      </div>
      <timeline>
        <timeline-title>
          <div>
            <span class="addr">[{{ tracks[0].addr }}]</span>
            {{ tracks[0].context }}
          </div>
          <div class="track-en">{{ tracks[0].en_content }}</div>
          <div class="f-12 time">{{ tracks[0].time }}</div>
        </timeline-title>
        <timeline-item v-for="(item, index) in tracks.slice(1)" :key="index">
          <div>
            <span class="addr">[{{ item.addr }}]</span> {{ item.context }}
          </div>
          <div class="track-en">{{ item.en_content }}</div>
          <div class="time f-12">{{ item.time }}</div>
        </timeline-item>
      </timeline>
    </main>
    <div class="card set-center" v-else>
      <img :src="emptyImg" class="track-no-img" />
      <div>{{ $t('暂无轨迹，请输入运单号查询') }}</div>
    </div>
  </div>
</template>
<script>
import { Timeline, TimelineItem, TimelineTitle } from 'vue-cute-timeline';
import { getTracks } from '@/api/deliver.js';
// 引入 van-progress 组件
import { Progress as VanProgress } from 'vant';

export default {
  components: {
    Timeline,
    TimelineItem,
    TimelineTitle,
    VanProgress, // 注册 van-progress 组件
  },
  data() {
    return {
      keyword: '',
      orderNo: '',
      tracks: [],
      emptyImg: require('../assets/images/noinfo.png'),
    };
  },
  computed: {
    // 计算进度百分比
    progressPercentage() {
      if (!this.tracks.length) return -1;

      // 这里需要根据实际业务逻辑计算进度
      // 暂时使用简单示例：假设有20个主要状态点
      const maxStatusCount = 20;
      const currentStatusCount = Math.min(this.tracks.length, maxStatusCount);
      return Math.round((currentStatusCount / maxStatusCount) * 100);
    },
  },

  mounted() {
    if (this.$route.query != null && this.$route.query.key != null) {
      let key = this.$route.query.key;
      if (key == null || key != '') {
        this.keyword = key;
        this.onSearch();
      }
    }
  },
  methods: {
    onSearch() {
      getTracks({ orderNo: this.keyword }).then(res => {
        this.orderNo = this.keyword;
        this.tracks = res.data;
      });
    },
    onClear() {
      this.keyword = '';
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.mb-x {
  margin-bottom: rem(40px);
}

/deep/ .timeline-title-circle {
  background-color: $theme-color;
}
/deep/ .timeline-item {
  border-bottom: 1px solid #f6f6f6;
}
.search-bar {
  padding: rem(40px) rem(20px);
  background-color: #fff;
}
.card {
  padding: rem(30px) rem(40px);
  background-color: #fff;
  margin-top: rem(10px);
  .track-no-img {
    width: rem(169px);
    margin: rem(10px);
  }
  .addr {
    color: #4588ec;
  }
}
.time {
  color: #666;
  font-size: 12px;
  margin-top: rem(20px);
}
.track-en {
  color: #979797;
}

.progress-container {
  display: flex;
  align-items: center;
  margin-bottom: rem(30px);
}

.progress-label {
  width: 25%;
  min-width: rem(80px);
  margin-right: rem(20px);
  white-space: nowrap;
  font-size: 14px;
}

.progress-bar-wrapper {
  flex: 1;
  min-width: 0; // 允许子元素收缩以适应容器
}
</style>
